import { render } from "./designImage.vue?vue&type=template&id=66ed73ee&scoped=true"
import script from "./designImage.vue?vue&type=script&lang=js"
export * from "./designImage.vue?vue&type=script&lang=js"

import "./designImage.vue?vue&type=style&index=0&id=66ed73ee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ed73ee"]])

export default __exports__